import { render, staticRenderFns } from "./DashboardProjectListItem.vue?vue&type=template&id=cac8b3da"
import script from "./DashboardProjectListItem.vue?vue&type=script&lang=js"
export * from "./DashboardProjectListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports